/**
 * MODULE: _shared/frontend-shell/src/components/nav/mobileBottomNavConfig.ts
 * PURPOSE: Tab definitions for shell mobile bottom navigation (Sprint 10 [2.2.1061]).
 * DEPENDENCIES: @heroicons/react/24/outline
 * PUBLIC_API: MOBILE_BOTTOM_NAV_TABS, isMobileBottomNavTabActive
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 */

import type { ComponentType } from 'react';
import {
  BriefcaseIcon,
  ClockIcon,
  Cog6ToothIcon,
  HomeIcon,
} from '@heroicons/react/24/outline';

export type MobileBottomNavTab = {
  id: string;
  label: string;
  path: string;
  icon: ComponentType<{ className?: string }>;
};

/** Primary mobile destinations — mirrors top-level rep workflow (Dashboard, Deals, Activity, Settings). */
export const MOBILE_BOTTOM_NAV_TABS: MobileBottomNavTab[] = [
  { id: 'dashboard', label: 'Dashboard', path: '/', icon: HomeIcon },
  { id: 'deals', label: 'Deals', path: '/crm/deals', icon: BriefcaseIcon },
  {
    id: 'activity',
    label: 'Activity',
    path: '/activity',
    icon: ClockIcon,
  },
  { id: 'settings', label: 'Settings', path: '/settings', icon: Cog6ToothIcon },
];

/** Active-state rules aligned with shell nav (`/` exact; CRM deals subtree; settings prefix). */
export function isMobileBottomNavTabActive(tabId: string, pathname: string): boolean {
  switch (tabId) {
    case 'dashboard':
      return pathname === '/';
    case 'deals':
      return pathname === '/crm/deals' || pathname.startsWith('/crm/deals/');
    case 'activity':
      return (
        pathname === '/activities' ||
        pathname.startsWith('/activities/') ||
        pathname === '/activity' ||
        pathname.startsWith('/activity/')
      );
    case 'settings':
      return pathname === '/settings' || pathname.startsWith('/settings/');
    default:
      return false;
  }
}
